import useSWR from 'swr';
import api from '@/utils/api';

/**
 * Fetcher para o SWR — usa o axios configurado (com token JWT)
 */
const fetcher = (url) => api.get(url).then((res) => res.data);

/**
 * Hook de cache de dados da API.
 * - Retorna dados em cache imediatamente (sem loading) na segunda visita à página
 * - Atualiza em background (stale-while-revalidate)
 * - Cache de 30 segundos por rota
 *
 * @param {string|null} url - URL da API (ex: '/contracts'). null desabilita o fetch.
 * @param {object} options - Opções extras do SWR
 */
export function useApiData(url, options = {}) {
  const { data, error, isLoading, mutate } = useSWR(url, fetcher, {
    // Não rebusca ao re-focar a janela (evita refetch ao voltar de aba)
    revalidateOnFocus: false,
    // 30 segundos de cache — requisições duplicadas na mesma janela são servidas do cache
    dedupingInterval: 30_000,
    // Mantém dados anteriores enquanto atualiza (sem flickering de loading)
    keepPreviousData: true,
    ...options,
  });

  return {
    data: data ?? null,
    error,
    isLoading,
    refresh: mutate, // Chame refresh() para forçar revalidação manual após mutações
  };
}

export default useApiData;
